import React, {Component, Fragment} from 'react'
import {observer} from 'mobx-react'

import TagSourceField from '../../struct/TagSourceField'
import FieldsGroup from '../../struct/FieldsGroup'
import Field from '../../struct/Field'
import Hint from '../../struct/Hint'
import Mono from '../../struct/Mono'
import SettingsGroup from '../../struct/SettingsGroup'
import InputText from '../../control/DependentInputText'
import Select from '../../control/DependentSelect'
import DeliveryDaysValidationError from '../../control/DeliveryDaysValidationError'
import Icon from 'lib/struct/icon/Icon';

import styles from './ProfileDeliverySettings.less'

const bool_options = [{
    label: 'Да',
    value: '1',
}, {
    label: 'Нет',
    value: '0',
}]

const delivery_options = [{
    label: 'Пропустить',
    value: '-1'
}, {
    label: 'Да',
    value: '1',
}, {
    label: 'Нет',
    value: '0',
}]

@observer export default class ProfileDeliverySettings extends Component {
    render() {
        const {title} = this.props
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const profile = context.profile

        return (
            <SettingsGroup
                title={title}
                titleClassName={styles['delivery__title']}
            >
                <Hint>
                    <Icon name="exclamation" />
                    Чтобы применялись условия доставки, в личном кабинете, на странице Подключение и настройки →
                    Настройки доставки, включите опцию Использовать данные из прайс-листа.
                </Hint>

                <TagSourceField
                    label="Возможна курьерская доставка"
                    tag="delivery"
                    flexible_content
                >
                    <Select
                        options={delivery_options}
                        value={profile.delivery_delivery}
                        onChange={e => profile.toggleShopDelivery(e.target.value)}
                        state={context.form_state}
                    />
                </TagSourceField>

                {
                    profile.delivery_delivery_options.length > 0 ? (
                        profile.delivery_delivery_options.map(option => (
                            <FieldsGroup key={option._unique_key}>
                                <DeliveryOptionComponent
                                    option={option}
                                    root_tag={'delivery-options'}
                                    state={context.form_state}
                                />
                            </FieldsGroup>
                        ))
                    ) : (null)
                }

                <TagSourceField
                    label="Возможен самовывоз"
                    tag="pickup"
                    flexible_content
                >
                    <Select
                        options={delivery_options}
                        value={profile.delivery_pickup}
                        onChange={e => profile.toggleShopPickup(e.target.value)}
                        state={context.form_state}
                    />
                </TagSourceField>

                {
                    profile.delivery_pickup_options.length === 1 ? (
                        <FieldsGroup>
                            <DeliveryOptionComponent
                                option={profile.delivery_pickup_options[0]}
                                root_tag={'pickup-options'}
                                state={context.form_state}
                            />
                        </FieldsGroup>
                    ) : (null)
                }

                <Field label="Возможность купить в оффлайне">
                    <Select
                        options={bool_options}
                        value={profile.delivery_store ? '1' : '0'}
                        onChange={e => profile.delivery_store = e.target.value === '1'}
                        state={context.form_state}
                    />
                    <Hint>Значение по-умолчанию для <Mono>{'<offer><store>'}</Mono></Hint>
                </Field>
            </SettingsGroup>
        )
    }
}

@observer
class DeliveryOptionComponent extends Component {
    render() {
        /** @type {DeliveryOption} */
        const option = this.props.option
        const form_state = this.props.state

        const {root_tag} = this.props

        return (
            <div className={styles['delivery__delivery-option-block']}>
                <TagSourceField
                    label="Стоимость"
                    tag={<Fragment>{root_tag}{'><'}option <b>cost</b>="..."</Fragment>}
                    flexible_content
                    indent_label
                >
                    <InputText
                        value={option.cost}
                        onChange={e => option.cost = e.target.value}
                        state={form_state}
                    />
                </TagSourceField>

                <TagSourceField
                    label="Сроки доставки"
                    tag={<Fragment>{root_tag}{'><'}option <b>days</b>="..."</Fragment>}
                    flexible_content
                    indent_label
                >
                    <InputText
                        value={option.days}
                        onChange={e => option.days = e.target.value}
                        state={form_state}
                    />
                    <DeliveryDaysValidationError days={option.days}/>
                </TagSourceField>

                <TagSourceField
                    label="Время приема заказа"
                    tag={<Fragment>{root_tag}{'><'}option <b>order-before</b>="..."</Fragment>}
                    flexible_content
                    indent_label
                >
                    <InputText
                        value={option.order_before}
                        onChange={e => option.order_before = e.target.value}
                        state={form_state}
                    />
                </TagSourceField>
            </div>
        )
    }
}